<template>
    <div class="c-template-card">
        <div class="template-card__top" v-if="showShare">
            <div class="template-card__icons">
                <img class="template-card__icon"
                     src="/assets/img/icons/gallery.svg"
                     alt="Image editable"
                     v-if="item.imageEditable" />

                <span class="template-card__icon"
                      v-if="item.textEditable">
                    Aa
                </span>
            </div>

            <div class="template-card__share">
                <button class="c-icon-button" @click="shareItem">
                    <img class="icon-button__icon"
                         src="/assets/img/icons/share.svg"
                         alt="Share" />
                </button>

                <button class="c-icon-button"
                        v-if="!isFavourite"
                        @click="addFavourite">
                    <img class="icon-button__icon"
                         src="/assets/img/icons/favourite.svg"
                         alt="Add to favourites" />
                </button>

                <button class="c-icon-button"
                        v-if="isFavourite"
                        @click="removeFavourite">
                    <img class="icon-button__icon"
                         src="/assets/img/icons/favourite-active.svg"
                         alt="Add to favourites" />
                </button>
            </div>
        </div>

        <div class="template-card__thumbnail">
            <a :href="item.url" :title="item.title" @click.prevent="increaseQuantity">
                <img :src="item.thumbnail + '?height=215'" :alt="item.title" />
            </a>
        </div>

        <div v-if="showControls" class="template-card__controls">
            <div class="template-card-counter">
                <button class="template-card-counter__button" @click="decreaseQuantity">
                    -
                </button>

                <input class="template-card-counter__input"
                       @change="changeQuantity"
                       v-model="quantity"
                       v-if="showQuantity" />

                <button class="template-card-counter__button" @click="increaseQuantity">
                    +
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            item: {
                type: Object,
                required: true
            },
            quantity: {
                type: Number,
                default: 0
            },
            isFavourite: {
                type: Boolean
            },
            showShare: {
                type: Boolean,
                default: true
            },
            showControls: {
                type: Boolean,
                default: true
            },
            showQuantity: {
                type: Boolean,
                default: true
            }
        },
        methods: {
            increaseQuantity: function () {
                this.quantity++;
                this.changeQuantity();
            },
            decreaseQuantity: function () {
                if (this.quantity > 0) {
                    this.quantity--;
                }
                this.changeQuantity();
            },
            changeQuantity: function () {
                if (this.quantity < 0) {
                    this.quantity = 0;
                }
                this.$emit("setQuantity", this.item, this.quantity);
            },
            shareItem: function () {
                this.$emit("shareItem", this.item);
            },
            addFavourite: function () {
                this.$emit("addFavourite", this.item);
            },
            removeFavourite: function () {
                this.$emit("removeFavourite", this.item);
            }
        }
    };
</script>